<ion-header [translucent]="true">
  <ion-toolbar>
    <ion-buttons slot="start">
      <lib-back-button (click)="handleGoBack()"></lib-back-button>
    </ion-buttons>
    <ion-title>{{ 'menu.deviceSettings.title' | transloco }}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content [fullscreen]="true" [scrollY]="true">
  <section class="root">
    <app-storage-information *libIfNative></app-storage-information>
    <ion-list-header> </ion-list-header>
    <ion-list [inset]="true">
      <ion-item>
        <app-delete-cache />
      </ion-item>
    </ion-list>
  </section>
</ion-content>
